module.exports = __webpack_public_path__ + "static/media/negotions-min.28148b9d.jpg";